import React from "react";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import Contacts from "../Contacts/Contacts";
import Footer from "../Footer/Footer";
import { Container, Col } from "reactstrap";

export default class AboutUs extends React.Component {
  render() {
    return (
      <div>
        <Container className="pt-5 mt-4">
          <SectionHeading title={"About Us"} />
          <Col xs="12" lg="12" className="text-center">
            <p>
              What if we could take this reality elsewhere? Somewhere, where we
              could feel what’s unreachable...
            </p>

            <p>
              We believe that each project has a story to be told, a beauty to
              be shown and a purpose to be fulfilled. From features to short
              films; commercials, music videos or any other way that makes us
              dream.
            </p>

            <p>
              And just like dreaming, we believe that cinema has this magical
              strength that transports the spectator to an emotional dimension.
              That’s why we’re always seeking for a modern cinematographic
              language, with a constant attention to detail. After all, we’re
              shooting for the moon.
            </p>

            <p>
              Moonway was created by Henrique Pina in 2016, a London-graduated
              and award-winning filmmaker with more than 10 years of experience.
            </p>
            <p>Join us on this trip.</p>
          </Col>
        </Container>
        <Contacts />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutUs/AboutUs.js